import * as React from 'react';
import { Tabs } from '@cian/ui-kit/prev';
import { scrollToAnchor, throttle } from '@cian/newbuilding-utils';
import classNames from 'classnames';
import { INavLinks, TSectionAnchor } from '../../settings';
import { setHash } from '../../utils';
import { Layout } from '../Layout';
import { getDOMSections, updateActiveSection, getNavLinksFromSections } from './helpers';
import * as styles from './Header.css';

interface IHeaderProps {
  isFixed: boolean;
  number?: React.ReactElement;
  callback?: React.ReactElement;
  logo?: React.ReactElement;
}

export const Header = React.forwardRef<HTMLElement, IHeaderProps>(function Header(props, ref) {
  const { isFixed, callback, logo, number } = props;
  const [navLinks, setNavLinks] = React.useState<INavLinks[]>([]);
  const [activeNavLink, setActiveNavLink] = React.useState<TSectionAnchor>('#');

  const handleActiveNavLinkChange = React.useCallback((value: TSectionAnchor) => {
    const anchor = `#${value}`;
    const event = new Event('click');

    scrollToAnchor({ anchor, offset: 50, hasRelocation: false })(event);

    setTimeout(() => {
      setActiveNavLink(value);
      setHash(value);
    }, 600);
  }, []);
  const sectionsChangeListener = throttle(600, () => updateActiveSection(navLinks, setActiveNavLink));

  React.useEffect(() => {
    setNavLinks(getNavLinksFromSections(getDOMSections()));
  }, []);

  React.useEffect(() => {
    window.addEventListener('scroll', sectionsChangeListener);

    return () => {
      window.addEventListener('scroll', sectionsChangeListener);
    };
  }, [sectionsChangeListener]);

  return (
    <header ref={ref} className={classNames(styles['header'], { [styles['header_fixed']]: isFixed })}>
      <Layout>
        <div className={styles['header__wrapper']}>
          <nav className={styles['navigation']}>
            {logo && <div className={styles['navigation__logo']}>{logo}</div>}

            <Tabs tabs={navLinks} activeTab={activeNavLink} onChange={handleActiveNavLinkChange} />
          </nav>

          <div className={styles['header__contacts']}>
            {number}
            {callback}
          </div>
        </div>
      </Layout>
    </header>
  );
});
